import styled from 'styled-components';
import { Text, FlexColumn, FlexRow } from '@make-software/tg-mini-app-ui';

export const OnchainContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    backgroundColor: '#30313B',
    padding: '20px 16px',
    alignItems: 'center',
    alignSelf: 'stretch',
    marginTop: 16,
    borderRadius: 8,
    border: '1px solid #41424E',
    gap: 8
  })
);

export const ActivityContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    backgroundColor: '#1C1D24',
    borderRadius: '8px',
    padding: '8px 16px',
    alignItems: 'flex-start',
    width: '90%'
  })
);

export const ActivityText = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: '#A9AAAD',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '-0.24px',
    lineHeight: '140%',
    fontFamily: 'Inter'
  })
);

export const ActivityPoints = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontWeight: '700',
    lineHeight: '140%',
    fontSize: '14px',
    fontFamily: 'JetBrains Mono, monospace'
  })
);

export const RoundActivityCardContainer = styled(FlexRow)<{ bgColor?: string }>(
  ({ theme, bgColor = '#30313B' }) =>
    theme.withMedia({
      backgroundColor: bgColor,
      borderRadius: 8,
      border: '1px solid #41424E',
      padding: '12px 16px',
      alignItems: 'flex-start',
      alignSelf: 'stretch'
    })
);

export const CardTopRow = styled.div(({ theme }) =>
  theme.withMedia({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',

    '@media (max-width: 555px)': {
      justifyContent: 'center'
    }
  })
);

export const LeftSide = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
    flex: '1 1 210px'
  })
);

export const FullWidthRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    width: '100%'
  })
);

export const ProjectTitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '14px',
    fontFamily: 'Inter'
  })
);

export const ProjectStatusDetails = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '11px',
    color: '#A9AAAD',
    fontWeight: '400',
    letterSpacing: '-0.22px',
    lineHeight: '140%',
    fontFamily: 'Inter'
  })
);

export const SvgIconContainer = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    width: '32px',
    height: '32px',
    borderRadius: 4,
    backgroundColor: '#1D243E',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto'
  })
);

export const EmptyContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    alignItems: 'center',
    justifyContent: 'center'
  })
);

export const CardTitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '14px',
    fontWeight: 700,
    letterSpacing: '-0.24px',
    lineHeight: '140%',
    fontFamily: 'Inter'
  })
);

export const CardSubtitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '12px',
    fontWeight: 600,
    color: 'rgba(255,255,255,0.70)',
    letterSpacing: '-0.2px',
    lineHeight: '140%',
    fontFamily: 'Inter'
  })
);

export const CountdownWrap = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 10px',
    borderRadius: 12,
    border: '1px solid rgba(255,255,255,0.10)',
    background: 'linear-gradient(180deg, rgba(18, 22, 44, 0.55) 0%, rgba(10, 12, 24, 0.35) 100%)',

    flexWrap: 'wrap',
    marginLeft: 'auto',

    '@media (max-width: 555px)': {
      marginLeft: 0,
      justifyContent: 'center',
      width: '100%'
    }
  })
);

export const CountdownUnit = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    alignItems: 'baseline',
    gap: 6,
    padding: '6px 8px',
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.08)',
    whiteSpace: 'nowrap'
  })
);

export const CountdownValue = styled.span(({ theme }) =>
  theme.withMedia({
    fontFamily: 'JetBrains Mono, monospace',
    fontSize: '14px',
    fontWeight: 800,
    color: '#FFFFFF',
    lineHeight: '14px',
    letterSpacing: '-0.3px',
    textShadow: '0px 6px 14px rgba(0,0,0,0.35)'
  })
);

export const CountdownLabel = styled.span(({ theme }) =>
  theme.withMedia({
    fontSize: '10px',
    fontWeight: 800,
    color: 'rgba(255,255,255,0.65)',
    lineHeight: '10px',
    letterSpacing: '0.6px',
    textTransform: 'uppercase'
  })
);

export const CountdownDivider = styled.div(({ theme }) =>
  theme.withMedia({
    width: 1,
    height: 18,
    backgroundColor: 'rgba(255,255,255,0.12)'
  })
);
